import React, { useEffect } from 'react';
import {
    postConversionEvent,
    cookieAccepted,
} from '../Actions/Conversion.action';

const Conversion = (props) => {
    useEffect(() => {
        const postFbEvent = async () => {
            await postConversionEvent(
                JSON.parse(props.event),
                props.eventName,
                props.customer ? JSON.parse(props.customer) : null
            );
        };
        if (
            window.Cookiebot &&
            window.Cookiebot.consent &&
            window.Cookiebot.consent.marketing
        ) {
            postFbEvent();
        } else {
            window.addEventListener(
                'CookiebotOnAccept',
                async function (e) {
                    if (window.Cookiebot.consent.marketing) {
                        postFbEvent();
                    }
                },
                false
            );
        }
    }, []);

    return null;
};
export default Conversion;
